/**
 * LES REACTIONS D'UN MESSAGE, cote interface : la liste FERMEE de quinze
 * emojis et leur cle de stockage, dans l'ordre : les quatre premiers sont ceux
 * de la PILULE posee au-dessus de la bulle (pouce, pouce bas, coeur, rire : retour 3 du
 * fondateur, 29/10), les onze autres sont derriere son « + ». Une fete deja posee reste valide ; `coeur` est une
 * reaction comme les autres. RECOPIE de `@taki/data-model`
 * (`REACTIONS_DE_MESSAGE`, `message.ts`), que ce package n'importe pas ; un
 * test compare les deux (`packages/sdk/tests/conversations-contrat.test.mjs`).
 */
export const REACTIONS_DU_MESSAGE = [
  { cle: 'pouce', emoji: '\u{1F44D}' },
  { cle: 'pouceBas', emoji: '\u{1F44E}' },
  { cle: 'coeur', emoji: '\u2764\uFE0F' },
  { cle: 'rire', emoji: '\u{1F602}' },
  { cle: 'surprise', emoji: '\u{1F62E}' },
  { cle: 'larmes', emoji: '\u{1F622}' },
  { cle: 'mainsJointes', emoji: '\u{1F64F}' },
  { cle: 'applaudissements', emoji: '\u{1F44F}' },
  { cle: 'fete', emoji: '\u{1F389}' },
  { cle: 'feu', emoji: '\u{1F525}' },
  { cle: 'cent', emoji: '\u{1F4AF}' },
  { cle: 'yeux', emoji: '\u{1F440}' },
  { cle: 'reflexion', emoji: '\u{1F914}' },
  { cle: 'muscle', emoji: '\u{1F4AA}' },
  { cle: 'fait', emoji: '\u2705' },
] as const;

export type CleDeReaction = (typeof REACTIONS_DU_MESSAGE)[number]['cle'];

/** Combien d'emojis tiennent dans la pilule, avant son « + » : les quatre premiers de la liste. */
export const NOMBRE_DE_REACTIONS_DE_LA_PILULE = 4;
/** Les quatre reactions de la pilule, au-dessus de la bulle, a l'echelle du texte. */
export const REACTIONS_DE_LA_PILULE = REACTIONS_DU_MESSAGE.slice(0, NOMBRE_DE_REACTIONS_DE_LA_PILULE);
/** Les autres, derriere le « + ». */
export const AUTRES_REACTIONS = REACTIONS_DU_MESSAGE.slice(NOMBRE_DE_REACTIONS_DE_LA_PILULE);

/**
 * Ce que chaque reaction DIT, pour les lecteurs d'ecran et l'infobulle :
 * l'emoji seul ne se lit pas.
 */
export const LIBELLES_DE_REACTION: Readonly<Record<CleDeReaction, string>> = {
  pouce: 'J’approuve',
  pouceBas: 'Je désapprouve',
  coeur: 'J’adore',
  rire: 'C’est drôle',
  surprise: 'Surprenant',
  larmes: 'C’est triste',
  mainsJointes: 'Merci',
  applaudissements: 'Bravo',
  fete: 'On fête ça',
  feu: 'Génial',
  cent: 'Parfait',
  yeux: 'Je regarde',
  reflexion: 'À réfléchir',
  muscle: 'Courage',
  fait: 'C’est fait',
};

/** Qui a reagi, par cle : la forme stockee (`message.reactions`). */
export type ReactionsDuMessage = Partial<Record<CleDeReaction, readonly string[]>>;

/** Une reaction posee, telle que l'ecran la compte. */
export interface ReactionComptee {
  cle: CleDeReaction;
  emoji: string;
  personnes: readonly string[];
  /** La personne connectee en fait partie. */
  deMoi: boolean;
}

/** Les reactions posees (au moins une personne), dans l'ordre de la liste fermee. */
export function reactionsComptees(reactions: ReactionsDuMessage | undefined, moi: string | null): ReactionComptee[] {
  return REACTIONS_DU_MESSAGE.flatMap(({ cle, emoji }) => {
    const personnes = reactions?.[cle] ?? [];
    return personnes.length === 0 ? [] : [{ cle, emoji, personnes, deMoi: moi !== null && personnes.includes(moi) }];
  });
}
